/**
 * CreateGamesStepSkeleton Component
 * Skeleton loader matching CreateGamesStep structure with league sections and GameMatchRow layout
 */

import React, { useMemo } from 'react';
import { View } from 'react-native';
import { Skeleton, SkeletonText } from '../../ui/Skeleton';
import { useTheme } from '../../../src/theme/useTheme';
import { getCreateGamesStepStyles } from './CreateGamesStep.styles';
import { getCreateGamesStepSkeletonStyles } from './CreateGamesStepSkeleton.styles';

function MatchRowSkeleton() {
  const theme = useTheme();
  const skStyles = useMemo(
    () => getCreateGamesStepSkeletonStyles(theme),
    [theme]
  );
  return (
    <View style={skStyles.matchRowSkeleton}>
      <View style={skStyles.matchRowSkeletonLeft}>
        <Skeleton width={40} height={12} borderRadius={4} />
        <SkeletonText width="70%" />
        <SkeletonText width="60%" />
      </View>
      <View style={skStyles.matchRowSkeletonOdds}>
        <View style={skStyles.matchRowSkeletonOddsBox} />
        <View style={skStyles.matchRowSkeletonOddsBox} />
        <View style={[skStyles.matchRowSkeletonOddsBox, skStyles.matchRowSkeletonOddsBoxLast]} />
      </View>
    </View>
  );
}

export const CreateGamesStepSkeleton: React.FC = () => {
  const theme = useTheme();
  const styles = useMemo(() => getCreateGamesStepStyles(theme), [theme]);

  return (
    <View testID="loading-skeleton">
      {[0, 1, 2].map((leagueIndex) => (
        <View key={`league-skeleton-${leagueIndex}`} style={styles.leagueSection}>
          <View style={styles.leagueHeaderContainer}>
            <View style={styles.leagueHeader}>
              <View style={styles.leagueHeaderContent}>
                <SkeletonText width={120} />
                <Skeleton width={14} height={14} borderRadius={2} />
              </View>
            </View>
          </View>

          <View style={styles.gamesContainer}>
            {[1, 2, 3].map((gameIndex) => (
              <View key={`game-skeleton-${leagueIndex}-${gameIndex}`} style={styles.gameContainer}>
                <MatchRowSkeleton />
              </View>
            ))}
          </View>
        </View>
      ))}
    </View>
  );
};

